import { Controller } from "@hotwired/stimulus";
import { numberToIdentifer } from "webpack/lib/Template";

export default class extends Controller {
  static targets = ["cardNumber", "buttonPay"];
  connect() {
    // console.log("credit-card-controller");
  }

  // Funcion que controla si la tarjeda ingresada es valida segun expresion regular de tardetas del mercado
  esNumeroTarjetaCredito() {
    this.numWithoutSpaces = this.cardNumberTarget.value.replace(/\s/g, "");
    this.patron =
      /^(?:4[0-9]{12}(?:[0-9]{3})?|[25][1-7][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
    return this.patron.test(this.numWithoutSpaces);
  }
  // Funcion que envia tooltip msge para avisar que la tarjeta es invalida.
  tooltipMsg() {
    // console.log("Es valido?", this.esNumeroTarjetaCredito());
    if (this.esNumeroTarjetaCredito() == false) {
      // console.log("onblur", "probando");
      this.cardNumberTarget.setCustomValidity("Tarjeta inválida");
      //   this.cardNumberTarget.reportValidity();
      //   this.cardNumberTarget.blur();
      // setAttribute("data-error", errorMessage);
      // this.cardNumberTarget.setAttribute("data-error", "Tarjeta inválida");
    } else {
      this.cardNumberTarget.setCustomValidity("");
    }
  }
}
